module.exports = __webpack_public_path__ + "img/4.7294e7d5.png";